import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3cab9dd8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "dialog"
};
const _hoisted_2 = {
  class: "message-dialog"
};
const _hoisted_3 = {
  class: "message-item"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item-label"
}, "昵称", -1));
const _hoisted_5 = {
  class: "item-text"
};
const _hoisted_6 = {
  class: "message-item"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item-label"
}, "姓名", -1));
const _hoisted_8 = {
  class: "item-text"
};
const _hoisted_9 = {
  class: "message-item"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item-label"
}, "手机号码", -1));
const _hoisted_11 = {
  class: "item-text"
};
const _hoisted_12 = {
  class: "dialog-footer"
};
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
export default /*#__PURE__*/_defineComponent({
  __name: 'parent-message-dialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    itemData: {
      type: Object,
      default: () => {}
    }
  },
  emits: ['closeDialog', 'restData'],
  setup(__props, {
    emit: __emit
  }) {
    const route = useRoute();
    const router = useRouter();
    const props = __props;
    const emit = __emit;
    function closeDialog() {
      emit('closeDialog');
    }
    function handleFooterBtn() {
      closeDialog();
    }
    const title = ref('上级信息');
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        "model-value": __props.dialogVisible,
        title: title.value,
        width: "25%",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": true,
        "before-close": closeDialog
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_12, [_createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = $event => handleFooterBtn()),
          type: "primary"
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, _toDisplayString(__props.itemData.nickname), 1)]), _createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, _toDisplayString(__props.itemData.realname), 1)]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("div", _hoisted_11, _toDisplayString(__props.itemData.mobile), 1)])])]),
        _: 1
      }, 8, ["model-value", "title"])]);
    };
  }
});